import { ModalWrapper } from "../../utils/fw"
import { RoundTables } from "../components/Roundtables"


export default {
	background: "https://assets.swoogo.com/uploads/full/1471887-619290d3e6320.jpg",
	extras: <RoundTables numTables={4} seatsPerTable={8} />,
	links: [
		{
			label: "Session Screen",
			width: "61.6%",
			height: "69.9%",
			left: "19.1%",
			top: "0.9%",
		},
		{
			label: "To Lobby",
			href: "/lobby",
			width: "15.6%",
			height: "8.4%",
			left: "1.6%",
			top: "1.1%",
		},
		{
			label: "Instructions",
			height: "9.5%",
			left: "82.3%",
			modal: <ModalWrapper dismissStyle={{ right: "2vw", top: "1vw" }} wrapperStyle={{ backgroundColor: "#7536f0" }}>
				<div style={{ color: "white", maxWidth: "50vw" }}>
					<h1>ROUNDTABLE SESSIONS INSTRUCTIONS</h1>
					<p>To join a discussion, click on a table. You will then automatically join a Video Meeting in the centre screen.</p>
					<p>If you’d like to switch to another table, simply click on the table you’d like to join, and you will automatically join the relevant meeting.</p>
					<p>All seats at the tables will populate with each individual currently participating in the discussion. You can click on a headshot to view who the individual is, as well as click to chat with them.</p>
					<p>There are no maximum capacities. If a table appears to be full, you can still join.</p>
				</div>
			</ModalWrapper>,
			top: "1.2%",
			width: "16.9%",
		},
		{
			label: "Product Q&A",
			width: "10.8%",
			height: "18.5%",
			left: "3.9%",
			top: "46.9%",
			CometChatID: "product"
		},
	],
	name: "networking",
}
